import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationService } from '../../../services/navigation.service';
import { FormService } from '../../../services/form.service';
import { UsanFormSectionStates } from '../../../models/usan-form-section-states.model';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ViewportScroller } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { SubstanceTypeEnum } from 'app/enums/substance-type-enum';
import { FormFactoryService } from 'app/services/form-factory.service';
import { FormConstants } from 'app/constants/form.constants';
import { AllCaseAttachmentsModel } from 'app/models/all-case-attachments.model';
import { FormValidationService } from 'app/services/form-validation.service';

@Component({
  selector: 'app-contact-lens-material-form',
  templateUrl: './contact-lens-material-form.component.html',
  styleUrls: ['./contact-lens-material-form.component.scss']
})

export class ContactLensMaterialFormComponent implements OnInit, OnDestroy {
  public SubstanceType = SubstanceTypeEnum;
  
  usanFormSectionStates!: UsanFormSectionStates;
  private usanFormSectionStatesSubscription: Subscription;
  private sizeChangeSubscription!: Subscription;
  private mobileDeviceSize: boolean = false;
  allCaseAttachments!: AllCaseAttachmentsModel;
  private allCaseAttachmentsSubscription: Subscription;

  constructor(
    protected navigationService: NavigationService, 
    protected formService: FormService, 
    protected formFactoryService: FormFactoryService,
    private responsive: BreakpointObserver, 
    protected scroller: ViewportScroller,
    protected formValidationService: FormValidationService
  ) {
      this.usanFormSectionStatesSubscription = this.navigationService.getUsanFormSectionStatesUpdate().subscribe(
        usanFormSection => {
          this.usanFormSectionStates = usanFormSection.value;
        });
      this.usanFormSectionStates = this.navigationService.getUsanFormSectionValue();

      this.allCaseAttachmentsSubscription = this.formService.getAllCaseAttachmentsUpdate().subscribe(
        attachments => {
          this.allCaseAttachments = attachments.value;
      });


      if(!this.currentForm) {
        this.formService.createUsanForm(FormConstants.SERVICE_NOW_FORM_E_TYPE);
      }
  }

  ngOnInit(): void {
    this.sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
      if(result.matches) {
        this.mobileDeviceSize = true;
      } else {
        this.mobileDeviceSize = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.usanFormSectionStatesSubscription.unsubscribe();
    this.sizeChangeSubscription.unsubscribe();
    this.allCaseAttachmentsSubscription.unsubscribe();
  }

  public scrollToSection(sectionId : string) : void {
    if(!this.mobileDeviceSize || !sectionId) {
      return;
    }

    this.scroller.scrollToAnchor(sectionId);
  }

  get isMobileDeviceSize(): boolean {
    return this.mobileDeviceSize;
  }

  get showBasicInfoPanel(): boolean {
    return this.usanFormSectionStates.showBasicInfoPanel;
  }

  get showMolecularInfoPanel(): boolean {
    return this.usanFormSectionStates.showMolecularInfoPanel;
  }

  get showSubstanceDetailsPanel(): boolean {
    return this.usanFormSectionStates.showSubstanceDetailsPanel;
  }

  get showManufactureUsageInfoPanel(): boolean {
    return this.usanFormSectionStates.showManufactureUsageInfoPanel;
  }

  get showClinicalTrialInfoPanel(): boolean {
    return this.usanFormSectionStates.showClinicalTrialInfoPanel;
  }

  get showApplicantInfoPanel(): boolean {
    return this.usanFormSectionStates.showApplicantInfoPanel;
  }

  get showPaymentInfoPanel(): boolean {
    return this.usanFormSectionStates.showPaymentInfoPanel;
  }

  get showUploadDocumentsPanel(): boolean {
    return this.usanFormSectionStates.showUploadDocumentsPanel;
  }

  get showTermsAndConditionsPanel(): boolean {
    return this.usanFormSectionStates.showTermsAndConditionsPanel;
  }

  set showBasicInfoPanel(showBasicInfoPanel: boolean) {
    this.usanFormSectionStates.showBasicInfoPanel = showBasicInfoPanel;
  }

  set showMolecularInfoPanel(showMolecularInfoPanel: boolean) {
    this.usanFormSectionStates.showMolecularInfoPanel = showMolecularInfoPanel;
  }

  set showSubstanceDetailsPanel(showSubstanceDetailsPanel: boolean) {
    this.usanFormSectionStates.showSubstanceDetailsPanel = showSubstanceDetailsPanel;
  }

  set showManufactureUsageInfoPanel(showManufactureUsageInfoPanel: boolean) {
    this.usanFormSectionStates.showManufactureUsageInfoPanel = showManufactureUsageInfoPanel;
  }

  set showClinicalTrialInfoPanel(showClinicalTrialInfoPanel: boolean) {
    this.usanFormSectionStates.showClinicalTrialInfoPanel = showClinicalTrialInfoPanel;
  }

  set showApplicantInfoPanel(showApplicantInfoPanel: boolean) {
    this.usanFormSectionStates.showApplicantInfoPanel = showApplicantInfoPanel;
  }

  set showPaymentInfoPanel(showPaymentInfoPanel: boolean) {
    this.usanFormSectionStates.showPaymentInfoPanel = showPaymentInfoPanel;
  }

  set showUploadDocumentsPanel(showUploadDocumentsPanel: boolean) {
    this.usanFormSectionStates.showUploadDocumentsPanel = showUploadDocumentsPanel;
  }

  set showTermsAndConditionsPanel(showTermsAndConditionsPanel: boolean) {
    this.formService.forceValidateForm();
    this.formService.showErrorSections();
    this.formService.invalidFormFields();
    this.usanFormSectionStates.showTermsAndConditionsPanel = showTermsAndConditionsPanel;
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

  public sectionHasError(sectionName: string): boolean {
    return this.formValidationService.sectionHasError(sectionName);
  }
}
